import { Box, Button, useTheme} from '@mui/material';

import { useBreakpoints } from '@frontend/features/common/hooks/useBreakpoints';

import { HotelSearchInput } from './HotelSearchInput';
import { HotelSearchRoomInput } from './HotelSearchRoomInput';
import { HotelSearchCalendar } from './HotelSearchCalendar';
import { useHotelSearch } from './HotelSearchContext';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export const HotelSearchBar = () => {
  const theme = useTheme();
  const {t} = useTranslation();
  const { isMediumUp } = useBreakpoints();
  const [minToDate] = useState(() => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);
    return minDate;
  });
  const {
    setSearchFromDate,
    setSearchToDate,
    searchData : searchHotelData,
    searchPropertyData,
    handleSubmitSearch : handleSubmitHotelSearch
  } = useHotelSearch();


  return (
    <>
      <Box
        display="flex"
        position="relative"
        width="100%"
        flexWrap= {isMediumUp ? 'nowrap' : 'wrap'}
        gap={theme.spacing(2)}
      >
        <HotelSearchInput/>
        <HotelSearchCalendar
          identifier='checkIn'
          value={searchHotelData.from}
          onChange={setSearchFromDate}
        />
        <HotelSearchCalendar
          minDate={minToDate}
          identifier='checkOut'
          value={searchHotelData.to}
          onChange={setSearchToDate}
        />
        <HotelSearchRoomInput />
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        width="100%"
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmitHotelSearch}
          disabled={
            (
              !searchHotelData.location &&
              !searchPropertyData.property?.nimbuxHotelId
            ) || 
            !searchHotelData.from ||
            !searchHotelData.to ||
            !searchHotelData.rooms
          }
        >
          {t('common.form.apply')}
        </Button>
      </Box>
    </>
  );
};
